export default __webpack_public_path__ + "static/media/flick.fb4e5391.mp3";